<template>
  <div class="game-player-info-compact">
    <div class="game-player-info-compact__left">
      <Avatar :player="player" :moveAction="moveAction"></Avatar>
    </div>

    <div class="game-player-info-compact__right">
      <div class="game-player-info-compact__player-info">
        <b class="game-player-info-compact__player-name">
          {{ playerName }}
        </b>
        <PlayerRating :rating="rating" :diff="ratingDiff" class="ml-2 mr-1" />
        <WinStreak class="ml-1" :winStreak="winStreak" />
      </div>
      <p class="game-player-info-compact__school-name">
        <i>{{ schoolName }}</i>
      </p>
    </div>
  </div>
</template>

<script>
import { CHESS_SIDE, GAME_RESULT } from "vue-chess-shared/constants";
import * as PlayerHelper from "vue-chess-shared/utils/player-helper";
import Avatar from "@/components/players/Avatar";
import WinStreak from "@/components/stats/WinStreak";
import PlayerRating from "@/components/stats/PlayerRating";

export default {
  components: {
    Avatar,
    WinStreak,
    PlayerRating,
  },
  name: "GamePlayerInfo",

  props: {
    color: {
      type: String,
      default: null,
    },
    gameData: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {};
  },

  computed: {
    player() {
      if (!this.gameData.match) return {};

      return this.color === CHESS_SIDE.WHITE
        ? this.gameData.match.player1
        : this.gameData.match.player2;
    },

    result() {
      if (!this.gameData.match) return null;
      return this.gameData.match.result;
    },

    rating() {
      if (this.player && this.player.stats) return this.player.stats.rating;
      return null;
    },

    ratingDiff() {
      if (this.player && this.player.stats) {
        return this.player.stats.rating_diff;
      }
      return null;
    },

    winStreak() {
      if (this.player && this.player.stats) return this.player.stats.win_streak;
      return null;
    },

    playerName() {
      return PlayerHelper.playerName(this.player);
    },

    schoolName() {
      if (!this.player || !this.player.school) return "";
      return this.player.school.school_name;
    },

    moveAction() {
      if (
        [
          GAME_RESULT.CHECKMATE,
          GAME_RESULT.TIMEOUT,
          GAME_RESULT.FORFEIT,
          GAME_RESULT.RESIGN,
        ].includes(this.result) &&
        this.score
      ) {
        return "victory";
      }

      if (!this.gameData.movesStats) return "idle";

      const lastMove = this.gameData.movesStats.at(-1);
      if (!lastMove) {
        return "idle";
      }

      // it's my move, check if it's a captured move
      if (lastMove.color === this.color && lastMove.move.includes("x")) {
        return "capture";
      }

      return "idle";
    },
  },
};
</script>

<style scoped>
.game-player-info-compact {
  display: flex;
}
.game-player-info-compact__left {
  width: 42px;
  height: 42px;
}
.game-player-info-compact__right {
  padding: 0px 5px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.game-player-info-compact__player-info {
  display: flex;
  align-items: center;
}
.game-player-info-compact__player-name {
  color: #7957d5;
}
.game-player-info-compact__school-name {
  color: #4a4a4a;
  font-style: italic;
  font-weight: 400;
  line-height: 1.25;
  font-size: 0.9rem;
  overflow-wrap: anywhere;
  text-align: left;
}
</style>
